export default "__VITE_ASSET__6f43011e__"